// Beneficiary case-studies — collected via Voice AI agents
// source: "Voice AI"

export const STORIES = [
  {
    id: "swapna",
    name: "Swapna Swargiary",
    pillar: "entrepreneurship",
    location: "Assam",
    partner: "Humana People to People India",
    source: "Voice AI",
    headline: "From handloom struggle to a thriving co-operative",
    quote:
      "Earlier, I wove just for my family. Today, I lead a group of 12 women weavers and our income has tripled.",
    impact: "₹18,000/month average household income (up from ₹5,500)",
  },
  {
    id: "minati",
    name: "Minati Pradhan",
    pillar: "entrepreneurship",
    location: "Odisha",
    partner: "Mahashakti Foundation",
    source: "Voice AI",
    headline: "Building a nano-enterprise from a kitchen garden",
    quote:
      "I started with one goat. Today, I supply organic vegetables to four villages around us.",
    impact: "Annual income up 4× through diversified rural enterprise",
  },
  {
    id: "ramesh",
    name: "Ramesh Naik",
    pillar: "employability",
    location: "Karnataka",
    partner: "EduBridge",
    source: "Voice AI",
    headline: "From village school to a Bangalore IT desk",
    quote:
      "I had never used a computer before joining. Six months later I am an associate at a tech company.",
    impact: "₹22,000/month — first salaried job in his family",
  },
  {
    id: "lakshmi",
    name: "Lakshmi Devi",
    pillar: "entrepreneurship",
    location: "Rajasthan",
    partner: "Tarun Bharat Sangh",
    source: "Voice AI",
    headline: "Reviving a dried johad through community labour",
    quote:
      "Our village wells went dry every March. Now, even in May the water lasts. We grew wheat this rabi.",
    impact: "8 hectares brought under cultivation; 32 households benefited",
  },
  {
    id: "anita",
    name: "Anita Kale",
    pillar: "employability",
    location: "Maharashtra",
    partner: "FUEL",
    source: "Voice AI",
    headline: "A single mother becomes a tally accountant",
    quote:
      "I had stopped studying after Class 10. The accounting course gave me both skills and confidence.",
    impact: "Hired as junior accountant at ₹19,000/month",
  },
  {
    id: "kavita",
    name: "Kavita Yadav",
    pillar: "entrepreneurship",
    location: "Madhya Pradesh",
    partner: "Humana People to People India",
    source: "Voice AI",
    headline: "From SHG member to micro-entrepreneur",
    quote:
      "Our self-help group's savings let me buy two sewing machines. I now run a tailoring unit with three women.",
    impact: "₹14,000/month average earnings for 4 women in the unit",
  },
];

export const SOURCE_META = {
  "Voice AI": { color: "#7C3AED", bg: "bg-violet-50", text: "text-violet-700", icon: "Mic" },
};
